import React from 'react';
import { FootnoteTwo, SubheadOne, SubheadTwo } from 'styled';
import { TextAreaBaseProps } from 'UI/types';
import {
  Container,
  TextArea as TextAreaInput,
  InputContainer,
  LeftChildContainer,
  RightChildContainer,
  RightSiblingContainer,
  Wrapper,
  ErrorContainer,
} from './styled';

function TextArea({
  theme = 'primary',
  label,
  subLabel,
  error,
  disabled,
  rightSibling,
  leftChild,
  rightChild,
  wrapperCSS = { width: '100%' },
  containerCSS = { width: '100%' },
  inputCSS,
  ...rest
}: TextAreaBaseProps) {
  return (
    <Wrapper $CSS={wrapperCSS}>
      <Container $CSS={containerCSS}>
        {label && (
          <SubheadOne
            as="label"
            $color={disabled ? '#6E6D82' : '#201E3F'}
            $marginBottom={4}
          >
            {label}
          </SubheadOne>
        )}
        {subLabel && (
          <SubheadTwo $weight="200" $marginBottom={8}>
            {subLabel}
          </SubheadTwo>
        )}
        <InputContainer>
          {leftChild && <LeftChildContainer>{leftChild}</LeftChildContainer>}
          <TextAreaInput
            {...rest}
            disabled={disabled}
            $theme={theme}
            $withError={Boolean(error)}
            $withLeftChild={Boolean(leftChild)}
            $withRightChild={Boolean(rightChild)}
            $CSS={inputCSS}
          />
          {rightChild && (
            <RightChildContainer>{rightChild}</RightChildContainer>
          )}
        </InputContainer>
        {error && (
          <ErrorContainer>
            <FootnoteTwo $color="#FF5934">{error}</FootnoteTwo>
          </ErrorContainer>
        )}
      </Container>
      {rightSibling && (
        <RightSiblingContainer>{rightSibling}</RightSiblingContainer>
      )}
    </Wrapper>
  );
}

export default TextArea;
